import type {
	ProgressToast,
	ProgressToastDestination,
	ProgressToastKind,
} from 'app/store/reducers/progressToasts.reducer';

type StartArgs = {
	id: string;
	kind: ProgressToastKind;
	count: number;
	itemName?: string;
	destination?: ProgressToastDestination;
	progress?: number | null;
};

export const startProgressToast = (args: StartArgs) => ({
	type: 'PROGRESS_TOAST_START' as const,
	payload: {
		id: args.id,
		kind: args.kind,
		count: args.count,
		itemName: args.itemName,
		destination: args.destination,
		progress: args.progress ?? null,
	} satisfies Omit<ProgressToast, 'status' | 'startedAt'>,
});

export const updateProgressToast = (id: string, progress: number | null) => ({
	type: 'PROGRESS_TOAST_UPDATE' as const,
	payload: { id, progress },
});

export const completeProgressToast = (
	id: string,
	overrides?: { count?: number; itemName?: string; itemId?: string },
) => ({
	type: 'PROGRESS_TOAST_COMPLETE' as const,
	payload: { id, ...(overrides ?? {}) },
});

export const failProgressToast = (id: string) => ({
	type: 'PROGRESS_TOAST_FAIL' as const,
	payload: { id },
});

export const dismissProgressToast = (id: string) => ({
	type: 'PROGRESS_TOAST_DISMISS' as const,
	payload: { id },
});
